/**
 * Renders a dropdown menu for mobile navigation
 * WARNING: Uses dummy data for competitions
 */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiChevronDown } from "react-icons/hi";
import { useQuery } from "@tanstack/react-query";

const MobileGamesDropdownMenu = ({
  closeMenu,
  overridebg,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    if (closeMenu) {
      closeMenu();
    }
  };

  const { isLoading, error, data } = useQuery({
    staleTime: Infinity,
    queryKey: ["division"],
    queryFn: () =>
        fetch(`${process.env.REACT_APP_BUIHA_API_URL}/division/`).then((res) =>
            res.json()
        ),
  });

  if (isLoading || error)
    return (
        <div className={overridebg ? "bg-light-4 dark:bg-dark-4" : "bg-light-2 dark:bg-dark-1"}>
          <button
        onClick={toggleDropdown}
        className={`w-full flex justify-start items-center pl-2 xs:pl-[12px] py-[6px] text-sm text-left ${!overridebg ? "font-medium" : "font-normal"}`}
      >
        <p className={`mr-1 font-smm leading-tight`}>Games (Loading)</p>
        <HiChevronDown /> {/*isOpen ? <HiChevronUp /> : <HiChevronDown />*/}
      </button>
        </div>
    );

  data && data.sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    // if overrridebg, dark-3 otherwiose dark4
    <div className={overridebg ? "bg-light-4 dark:bg-dark-4" : "bg-light-2 dark:bg-dark-1"}>
      <button
        onClick={toggleDropdown}
        className={`w-full flex justify-start items-center pl-2 xs:pl-[12px] py-[6px] text-sm text-left ${!overridebg ? "font-medium" : "font-normal"}`}
      >
        <p className={`mr-1 font-smm leading-tight`}>Games</p>
        <HiChevronDown /> {/*isOpen ? <HiChevronUp /> : <HiChevronDown />*/}
      </button>
      {isOpen && (
        <div className="flex flex-col bg-light-1 dark:bg-dark-4 py-0.5">
          <Link
            key={1}
            to={"/gamecentre"}
            className="py-[7px] pl-2 xs:pl-[10px] text-sm"
            target={"_self"}
            onClick={handleLinkClick}
          >
            <div className="flex flex-row items-center justify-start">
              <img src="/buihamini.png" alt="BUIHA Logo" className="w-5 h-5 mr-1" />
              <p className="text-smm mr-1 leading-tight">Gamecentre</p>
            </div>
          </Link>
          <div className="flex border-t-2 dark:border-dark-3 mx-[10px]"></div>
          <div className="flex flex-row">
            <div className="flex flex-col items-start w-1/2">
            <div className="flex flex-row items-start justify-start">
                  <div className="py-[7px] pl-2 xs:pl-[10px] text-smm mr-1 leading-tight flex flex-row">
                    <img src="/buihamini.png" alt="BUIHA Logo" className="w-6 h-6 mr-1"/>
                    Cup Comp North
                  </div>
                </div>

              {data ? (
                  data.map((division) =>
                      // If club.status == active, then show the club
                      // division.status === "Active" &&
                      division.conference === "North" ? (
                          <Link
                              key={2}
                              to={"/division/" + division.id}
                              className="py-[3px] pl-2 xs:pl-[10px] text-smm"
                              target={"_self"}
                              onClick={handleLinkClick}
                          >{division.title}</Link>
                      ) : null
                  )
              ) : (
                  <></>
              )}
            </div>
            <div className="flex flex-col items-start w-1/2">
            <div className="flex flex-row items-start justify-start">
                  <div className="py-[7px] pl-2 xs:pl-[10px] text-smm mr-1 leading-tight flex flex-row">
                    <img src="/buihamini.png" alt="BUIHA Logo" className="w-6 h-6 mr-1"/>
                    Cup Comp South
                  </div>
                </div>
              {data ? (
                  data.map((division) =>
                      // If club.status == active, then show the club
                      // division.status === "Active" &&
                      division.conference === "South" ? (
                          <Link
                              key={2}
                              to={"/division/" + division.id}
                              className="py-[3px] pl-2 xs:pl-[10px] text-smm"
                              target={"_self"}
                              onClick={handleLinkClick}
                          >{division.title}</Link>
                      ) : null
                  )
              ) : (
                  <></>
              )}
            </div>
          </div>
          <div className="flex border-t-2 dark:border-dark-3 mt-1 mx-[10px]"></div>
          <div className="flex flex-wrap">
          <div className="flex flex-row items-start justify-start w-full">
                  <div className="py-[7px] pl-2 xs:pl-[10px] text-smm mr-1 leading-tight flex flex-row">
                  <img src="https://buiha.org.uk/assets/img/icon/150/nationals.png" alt="BUIHA Logo" className="w-6 h-6 mr-1"/>
                  National Championships</div>
                </div>

            <div className="flex flex-col items-start w-1/2">
            {data ? (
                data.map((division) =>
                    // If club.status == active, then show the club
                    // division.status === "Active" &&
                    division.is_nationals === true && division.short !== "N-CHK" ? (
                        <Link
                            key={2}
                            to={"/division/" + division.id}
                            className="py-[3px] pl-2 xs:pl-[10px] text-smm"
                            target={"_self"}
                            onClick={handleLinkClick}
                        >{division.title}</Link>
                    ) : null
                )
            ) : (
                <></>
            )}
            </div>

            <div className="flex flex-col items-start w-1/2">

            {data ? (
                data.map((division) =>
                    // If club.status == active, then show the club
                    // division.status === "Active" &&
                    division.is_nationals === true && division.short === "N-CHK" ? (
                        <Link
                            key={2}
                            to={"/division/" + division.id}
                            className="py-[3px] pl-2 xs:pl-[10px] text-smm"
                            target={"_self"}
                            onClick={handleLinkClick}
                        >{division.title}</Link>
                    ) : null
                )
            ) : (
                <></>
            )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileGamesDropdownMenu;
